import React, { useCallback, useEffect, useState } from 'react'

// react redux
import { connect } from 'react-redux'

// react bootstrap
import { Container, Spinner } from 'react-bootstrap'

// react router
import { useHistory } from 'react-router-dom'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// API's
import { getCartItemsWithOrderId } from 'utlis/Apis/Cart_API';

// toast
import { toast } from 'react-toastify'

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED
} from 'utlis/AppMessages/AppMessages'
import { setGlobalLoading } from 'redux/actions/actionCommon';

// page components
import ProductsView from './Includes/PageComponents/ProductsView'
import AdditionalInformation from './Includes/PageComponents/AdditionalInformation'
// modal
import SendEmailModal from 'components/AbandonedCart/Pages/AbandonedCartDetails/Includes/PageComponents/Modal/SendEmailModal';

function AbandonedCartDetails(props) {
    // props
    const {
        commonToken,
        currentUser,

        match,

        setGlobalLoading
    } = props

    // consts
    const history = useHistory()

    // states
    const [moreOptionsDropdown, setMoreOptionsDropdown] = useState(false)
    const [pageLoading, setPageLoading] = useState(false)
    const [orderDetails, setOrderDetails] = useState({})
    const [currenTemptOrderId, setCurrenTemptOrderId] = useState("")

    const [trackingModalVisibility, setTrackingModalVisibility] = useState(false)
    const [userAddress, setUserAddress] = useState(null)

    // on go back press
    const handleBackPress = ev => {
        ev.preventDefault()

        history.goBack() // going back in history
    }

    // GETTING TEMP ORDER ID
    useEffect(() => {
        if (orderDetails?.content?.length) {
            const address = orderDetails.content[0]?.address
            if (address) {
                setUserAddress(JSON.parse(address)[0])
            }
        }
    }, [orderDetails])

    // SETTING USER ADDRESS1
    useEffect(() => {
        const idFromUrl = match?.params?.id;
        if (idFromUrl) {
            setCurrenTemptOrderId(idFromUrl)
        }
    }, [match])

    const getCartItemFunc = useCallback(() => {
        if (currenTemptOrderId) {
            // global loading
            // setGlobalLoading(true)
            setPageLoading(true)

            getCartItemsWithOrderId(commonToken, currenTemptOrderId).then(res => {
                // global loading
                // setGlobalLoading(false)
                setPageLoading(false)

                const resData = res.data

                console.log('resData ', resData);

                // if request is success
                if (resData?.success) {
                    const mainData = resData.data

                    setOrderDetails(mainData) // setting order data
                }

                // if request is error
                if (resData?.error) {
                    // closing all the other toasts
                    toast.dismiss();

                    // showing error toast
                    toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} get abandonedCart `, err.message)

                // closing all the other toasts
                toast.dismiss();

                // showing error toast
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // global loading
                        // setGlobalLoading(false)
                        setPageLoading(false)
                    }
                })
            })
        }
    }, [commonToken, currenTemptOrderId])

    // getting cart items
    useEffect(() => {
        getCartItemFunc()
    }, [getCartItemFunc])

    // open modal
    const openTrackingModal = ev => {
        ev.preventDefault()

        setTrackingModalVisibility(true) // opening modal

        setMoreOptionsDropdown(false) // close the dropdown
    }
    // close modal
    const closeTrackingModal = () => {
        setTrackingModalVisibility(false) // close modal 
    }

    return (
        <section id="app-abandonedCart" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-abandonedCart">
                    {/* back button */}
                    <div className="back-button-wrapper mb-3">
                        <a href="/"
                            className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-14 st-fw-600"
                            onClick={handleBackPress}>
                            <FeatherIcon
                                icon="arrow-left"
                                size="16"
                                className="icon me-1" />
                            <span>Back to Aboandoned Cart</span>
                        </a>
                    </div>

                    {/* header */}
                    <div className="app-header-wrapper d-flex flex-column mb-2">
                        <p className="app-heading text-capitalize st-fw-700">Abandoned Cart Details</p>

                        <div className="links d-flex">
                            <a
                                href="/"
                                onClick={ev => {
                                    ev.preventDefault()
                                    window.print()
                                }}
                                className="st-text-primary hover-underline-link st-fs-14 st-fw-400"
                            >
                                <FeatherIcon
                                    icon="printer"
                                    size="13"
                                    className="icon" />
                                <span className="ms-2 position-relative" style={{ top: 1 }}>Print Page</span>
                            </a>

                            {/* update */}
                            <div className="sales-order-dropdown position-relative ms-2" onClick={ev => ev.stopPropagation()}>
                                <a href="/" className="head d-flex hover-underline-link align-items-center text-decoration-none" onClick={ev => {
                                    ev.preventDefault()
                                    setMoreOptionsDropdown(!moreOptionsDropdown) // toggeling the dropdown menu
                                }}>
                                    <span className="me-2">Update</span>
                                    {
                                        moreOptionsDropdown ? (
                                            <FeatherIcon
                                                icon="chevron-up"
                                                size="16"
                                                className="icon me-1"
                                            />
                                        ) : (
                                            <FeatherIcon
                                                icon="chevron-down"
                                                size="16"
                                                className="icon me-1"
                                            />
                                        )
                                    }
                                </a>

                                {
                                    /* dropdown content */
                                    moreOptionsDropdown ? (
                                        <div className="dropdown-content position-absolute" style={{ width: 160 }}>
                                            <div className="inner">
                                                <a
                                                    href="/"
                                                    className="link text-decoration-none d-flex p-3"
                                                    onClick={openTrackingModal}>
                                                    Send Recovery Email
                                                </a>
                                            </div>
                                        </div>
                                    ) : null
                                }
                            </div>

                        </div>
                    </div>

                    {/* content */}
                    <div className="app-content-container abandoned-details-content">
                        <div className="app-card d-flex flex-wrap position-relative">
                            {/* lt sec */}
                            <div className="lt-sec media-body pe-4">
                                <div className="inner">
                                    {/* page border box */}
                                    <div className="page-border-box mb-3">
                                        <div className="pbb-inner">
                                            {/* frac */}
                                            <div className="frac d-flex align-items-center">
                                                <div className="lt media-body pe-2">
                                                    <p className="product-date">
                                                        {orderDetails?.cart_total ?? ""}
                                                        <span className="seprator"></span>
                                                        {orderDetails?.content?.length ? orderDetails.content[0]?.cart_added_date : ""}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <ProductsView
                                        orderDetails={orderDetails}
                                    />

                                    {/* additional info */}
                                    <AdditionalInformation
                                        orderDetails={orderDetails}
                                    />

                                    {/* page border box */}
                                    {/* <div className="page-border-box mb-4">
                                        <div className="pbb-inner">
                                            <p className="head st-fw-600 st-text-color2 st-fs-16 mb-3">Additional information</p>
                                            <p className="st-fs-15 mb-1">IP Address: 72.34.179.202</p>
                                            <p className="st-fs-15 mb-0">Accepts email marketing: No, promo emails not allowed</p>
                                        </div>
                                    </div> */}

                                </div>
                            </div>

                            {/* rt sec */}
                            <div className="rt-sec">
                                <div className="inner">
                                    {/* page border box */}
                                    <div className="page-border-box">
                                        <div className="pbb-inner border-bottom">
                                            {/* frac */}
                                            <div className="frac">
                                                <div className="header-container d-flex mb-3">
                                                    <div className="in media-body">
                                                        <p className="head st-fw-600 st-text-color2 st-fs-16 mb-2">Customer Email</p>
                                                        {
                                                            /* frac item */
                                                            orderDetails?.content?.length ? (
                                                                <React.Fragment>
                                                                    {
                                                                        orderDetails.content[0]?.email ? (
                                                                            <a href={`mailto:${orderDetails.content[0]?.email}`} className="useremail hover-underline-link st-fs-15">
                                                                                {orderDetails.content[0]?.email}
                                                                            </a>
                                                                        ) : null
                                                                    }
                                                                </React.Fragment>
                                                            ) : null
                                                        }
                                                    </div>

                                                    <div className="in ms-auto">
                                                        <a className="st-round-btn st-btn-primary d-flex align-items-center justify-content-center" style={{ pointerEvents: 'none' }} title="User" href="/">
                                                            <FeatherIcon
                                                                icon="mail"
                                                                size="15"
                                                                className="icon position-relative" />
                                                        </a>
                                                    </div>
                                                </div>

                                                <div className="header-container d-flex">
                                                    <div className="in media-body">
                                                        <p className="head st-fw-600 st-text-color2 st-fs-16 mb-2">Shipping address</p>
                                                        {
                                                            console.log('userAddress ', userAddress)
                                                        }
                                                        { // if user has added his/her address
                                                            (userAddress && userAddress !== null) ? (
                                                                <p className="mb-1 st-fs-15">
                                                                    <span>
                                                                        {`${userAddress.shipping_first_name ?? ""} ${userAddress.shipping_middle_name ?? ""} ${userAddress.shipping_last_name ?? ""}`}
                                                                    </span> <br />
                                                                    <span>
                                                                        {userAddress.shipping_address ?? ""}
                                                                    </span> <br />
                                                                    {
                                                                        (userAddress?.shipping_address1) ? (
                                                                            <React.Fragment>
                                                                                <span>
                                                                                    {userAddress.shipping_address1}
                                                                                </span> <br />
                                                                            </React.Fragment>
                                                                        ) : null
                                                                    }
                                                                    <span>
                                                                        {userAddress.shipping_city ?? ""}, {userAddress.shipping_state ?? ""}                                                            </span> <br />
                                                                    <span>
                                                                        {userAddress.shipping_zipcode ?? ""} {userAddress.shipping_country ?? ""}
                                                                    </span>
                                                                </p>
                                                            ) : (
                                                                <p>No address added</p>
                                                            )
                                                        }
                                                    </div>

                                                    <div className="in ms-auto">
                                                        <a className="st-round-btn st-btn-transparent d-flex align-items-center justify-content-center" style={{ pointerEvents: 'none' }} title="User" href="/" style={{ visibility: "hidden", pointerEvents: "none" }}>
                                                            <FeatherIcon
                                                                icon="truck"
                                                                size="20"
                                                                className="icon" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {
                                // page loading
                                pageLoading ? (
                                    <div
                                        className="page-loading position-absolute h-100 w-100 d-flex justify-content-center align-items-center"
                                        style={{ top: 0, left: 0, background: 'rgba(255, 255, 255, 0.6)', zIndex: 99 }}>
                                        <Spinner animation="border" />
                                    </div>
                                ) : null
                            }
                        </div>
                    </div>


                </div>
            </Container>

            {/* modals */}
            <SendEmailModal
                modalVisibility={trackingModalVisibility}
                closeModal={closeTrackingModal}

                orderDetails={orderDetails}
                tempOrderId={currenTemptOrderId}
            />
        </section>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        commonToken: state.auth.commonToken,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: (prop) => dispatch(setGlobalLoading(prop)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(AbandonedCartDetails)